interface UseCatalogAccessPermissionsParams {
  isReadOnly?: boolean;
}

export const useCatalogAccessPermissions = ({ isReadOnly }: UseCatalogAccessPermissionsParams) => {
  const canAddEntity = !isReadOnly;
  const canRemoveEntity = !isReadOnly;
  const canEditDates = !isReadOnly;

  return { canAddEntity, canRemoveEntity, canEditDates };
};
